import { render } from "./UserRoleList.vue?vue&type=template&id=476fc6be&scoped=true"
import script from "./UserRoleList.vue?vue&type=script&lang=js"
export * from "./UserRoleList.vue?vue&type=script&lang=js"

import "./UserRoleList.vue?vue&type=style&index=0&id=476fc6be&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476fc6be"]])

export default __exports__